const canonical = email => String(email || '').trim().toLowerCase();
const ranks = { 'Email Sent': 1, 'Email Opened': 2, 'Clicked Link': 3, 'Submitted Data': 4 };
const validTime = value => { const time = new Date(value).getTime(); return value && Number.isFinite(time) ? time : null; };

export function recipientResults(results, timeline) {
  const eventsByEmail = new Map();
  (timeline || []).forEach(event => {
    const email = canonical(event.email);
    if (!email) return;
    if (!eventsByEmail.has(email)) eventsByEmail.set(email, []);
    eventsByEmail.get(email).push(event);
  });
  return (results || []).map(result => {
    const events = eventsByEmail.get(canonical(result.email)) || [];
    const messages = new Set(events.map(event => event.message));
    const rank = events.reduce((rank, event) => Math.max(rank, ranks[event.message] || 0), ranks[result.status] || 0);
    const firstTime = message => {
      const times = events.filter(event => event.message === message).map(event => validTime(event.time)).filter(time => time !== null);
      return times.length ? new Date(Math.min(...times)) : null;
    };
    return { ...result, fullName: [result.first_name, result.last_name].filter(Boolean).join(' ') || result.email,
      sent: rank >= 1, opened: rank >= 2, clicked: rank >= 3, submitted: rank >= 4,
      reported: result.reported === true || messages.has('Email Reported'),
      error: ['Error', 'Error Sending Email'].includes(result.status),
      clickedAt: firstTime('Clicked Link'), submittedAt: firstTime('Submitted Data'), reportedAt: firstTime('Email Reported') };
  });
}

export function recipientTimeline(timeline, email) {
  return (timeline || []).filter(event => !canonical(event.email) || canonical(event.email) === canonical(email))
    .sort((a, b) => (validTime(a.time) ?? Infinity) - (validTime(b.time) ?? Infinity));
}

export const recipientStatusKeys = { Created: 'created', Scheduled: 'scheduled', Sending: 'sending',
  'Email Sent': 'sent', 'Email Opened': 'opened', 'Clicked Link': 'clicked', 'Submitted Data': 'submitted',
  'Email Reported': 'reported', Error: 'error', 'Error Sending Email': 'error', 'Campaign Created': 'campaign_created', 'Campaign Completed': 'campaign_completed' };
